import { Fragment, useEffect, useState } from "react";
import { tableHeaders } from "../../hooks/constants";
// import { checkAuthenticated } from "../../actions/auth";
// import { useDispatch } from "react-redux";
import { load_transactions_list } from "../../actions/payment_management";
import { Button } from "react-bootstrap";
import TableContainer from "./TableContainer";
import TransactionModal from "../Modals/TransactionModal";
import { hasPermission } from "../../hooks/userPermissions";

const TransactionTable = ({
  transactionType = "",
  refreshTable,
  optionName = "",
  dateValues,
  user,
}) => {
  // const dispatch = useDispatch();
  const [transactionList, setTransactionList] = useState([]);
  const [modalsData, setModalsData] = useState({
    transactionModalId: null,
    transactionModalShow: false,
  });

  const fetchTransactionsList = async () => {
    const { year, month } = dateValues;

    const data = await load_transactions_list({
      year,
      month,
      active_type: optionName,
      transaction_type: transactionType,
    });
    if (data) {
      setTransactionList(data.results);
    }
  };
  const handleTransactionEdit = (transactionId) => {
    setModalsData({
      ...modalsData,
      transactionModalId: transactionId,
      transactionModalShow: true,
    });
  };
  const tableConfigTransactions = {
    headers: tableHeaders.transactionsTable,
    checkable: false,
    detailFunction: handleTransactionEdit,
    listData: transactionList,
    // initialSort: "created",
    initialDirection: "desc"
  };
  useEffect(() => {
    // dispatch(checkAuthenticated());

    fetchTransactionsList();
  }, [dateValues, optionName]);
  return (
    <Fragment>
      <div className="list-header d-flex justify-content-between mb-2">
        <h4>Transacciones recientes</h4>
        <div className="d-flex gap-2 mx-2 h-50">
          <Button
            variant="outline-secondary"
            onClick={() => refreshTable(fetchTransactionsList)}
          >
            <i className="bi bi-arrow-clockwise" />
          </Button>
          {/* <Button variant="outline-secondary d-flex align-items-center gap-2">
            Exportar en Excel
          </Button> */}
          {hasPermission(user, "create:transaction") && (
            <Button
              variant="primary d-flex align-items-center gap-2"
              onClick={() =>
                setModalsData({
                  ...modalsData,
                  transactionModalShow: true,
                })
              }
            >
              Agregar Transaccion
              <i className="bi bi-plus-circle" />
            </Button>
          )}
        </div>
      </div>
      <TableContainer tableConfig={tableConfigTransactions} />

      <TransactionModal
        show={modalsData.transactionModalShow}
        onHide={() => {
          fetchTransactionsList();
          setModalsData({
            ...modalsData,
            transactionModalId: null,
            transactionModalShow: false,
          });
        }}
        transactionId={modalsData.transactionModalId}
      />
    </Fragment>
  );
};

export default TransactionTable;
